import { ComponentProps, FC } from 'react';

import { SvgIcon } from './SvgIcon';

export const Eraser: FC<ComponentProps<typeof SvgIcon>> = props => (
  <SvgIcon width="20" height="20" viewBox="0 0 20 20" {...props}>
    <path d="M14.2401 1.5601L19.1901 6.5001C19.9701 7.2901 19.9701 8.5501 19.1901 9.3401L10.0001 18.5301C8.4401 20.0901 5.9101 20.0901 4.3401 18.5301L0.810098 15.0001C0.0300977 14.2101 0.0300977 12.9501 0.810098 12.1601L11.4101 1.5601C12.2001 0.780098 13.4601 0.780098 14.2401 1.5601ZM2.2201 13.5801L5.7601 17.1101C6.5401 17.9001 7.8001 17.9001 8.5901 17.1101L12.1201 13.5801L7.1701 8.6301L2.2201 13.5801Z" />
  </SvgIcon>
);
